import { useMutation } from "@tanstack/react-query";
import { producaoService, Producao } from "../services/producaoService";

export interface CreateProducaoData {
  lojaId: number;
  usuarioId: number;
  bordaId: number;
  tamanhoId: number;
}

export const useCreateProducao = () => {
  return useMutation<Producao, Error, CreateProducaoData>({
    mutationFn: (data) => producaoService.create(data),
  });
};

export const useFinalizarProducao = () => {
  return useMutation<Producao, Error, number>({
    mutationFn: (id) => producaoService.finalizar(id),
  });
};

export const useDeleteProducao = () => {
  return useMutation<void, Error, number>({
    mutationFn: (id) => producaoService.delete(id),
  });
};
